import { call, put, takeLatest, takeLeading } from "redux-saga/effects";
import { API } from "../api";
import { ORDER_CREATE, ORDER_CREATE_FAIL, ORDER_CREATE_SUCCESS, CUSTOMER_ORDER_LIST, CUSTOMER_ORDER_LIST_SUCCESS, CUSTOMER_ORDER_LIST_FAIL, CUSTOMER_ORDER_DETAIL, CUSTOMER_ORDER_DETAIL_SUCCESS, CUSTOMER_ORDER_DETAIL_FAIL, CUSTOMER_ORDER_UPDATE, CUSTOMER_ORDER_UPDATE_SUCCESS, CUSTOMER_ORDER_UPDATE_FAIL, PERSONAL_SHOPPER_LIST_SUCCESS, PERSONAL_SHOPPER_LIST_FAIL, PERSONAL_SHOPPER_ASSIGN_SUCCESS, PERSONAL_SHOPPER_ASSIGN_FAIL, PERSONAL_SHOPPER_LIST, PERSONAL_SHOPPER_ASSIGN, CREATE_PAYMENT_ORDER, CREATE_PAYMENT_ORDER_SUCCESS, CREATE_PAYMENT_ORDER_FAIL, VERIFY_PAYMENT, VERIFY_PAYMENT_SUCCESS, VERIFY_PAYMENT_FAIL, GET_PAYMENTS, GET_PAYMENTS_SUCCESS, GET_PAYMENTS_FAIL, RETRY_PAYMENT, RETRY_PAYMENT_SUCCESS, RETRY_PAYMENT_FAIL } from "../actions/OrderAction";

function* orderCreate(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.orderCreate, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess(response.data);
    }
    yield put({
      type: ORDER_CREATE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({
      type: ORDER_CREATE_FAIL,
      payload: { error: error },
    });
  }
}

function* orderList(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.customerOrderList, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: CUSTOMER_ORDER_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: CUSTOMER_ORDER_LIST_FAIL,
      payload: { error: error },
    });
  }
}

function* orderDetail(action) {
  try {
    const { id, onSuccess } = action.payload;
    const response = yield call(API.customerOrderById, id);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: CUSTOMER_ORDER_DETAIL_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: CUSTOMER_ORDER_DETAIL_FAIL,
      payload: { error: error },
    });
  }
}

function* orderUpdate(action) {
  try {
    const { id, onSuccess, ...body } = action.payload;
    const response = yield call(API.customerOrderUpdate, id, body);
    if (typeof onSuccess === "function") {
      onSuccess(response.data);
    }
    yield put({
      type: CUSTOMER_ORDER_UPDATE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({
      type: CUSTOMER_ORDER_UPDATE_FAIL,
      payload: { error: error },
    });
  }
}

function* personalShoperList(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.personalShopperList, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: PERSONAL_SHOPPER_LIST_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PERSONAL_SHOPPER_LIST_FAIL,
      payload: { error: error },
    });
  }
}

function* personalShopperAssign(action) {
  try {
    const { onSuccess, ...otherPayload } = action.payload;
    const response = yield call(API.personalShopperAssign, otherPayload);
    if (typeof onSuccess === "function") {
      onSuccess();
    }
    yield put({
      type: PERSONAL_SHOPPER_ASSIGN_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PERSONAL_SHOPPER_ASSIGN_FAIL,
      payload: { error: error },
    });
  }
}

function* createPaymentOrderSaga(action) {
  try {
    const { orderId, onSuccess } = action.payload;
    const response = yield call(API.createPaymentOrder, orderId);
    if (typeof onSuccess === "function") {
      onSuccess(response.data);
    }
    yield put({
      type: CREATE_PAYMENT_ORDER_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({
      type: CREATE_PAYMENT_ORDER_FAIL,
      payload: { error: error },
    });
  }
}

function* verifyPaymentSaga(action) {
  try {
    const { orderId, data, onSuccess } = action.payload;
    const response = yield call(API.verifyPayment, orderId, data);
    if (typeof onSuccess === "function") {
      onSuccess(response.data);
    }
    yield put({
      type: VERIFY_PAYMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({
      type: VERIFY_PAYMENT_FAIL,
      payload: { error: error },
    });
  }
}

function* getPaymentsSaga(action) {
  try {
    const { orderId, onSuccess } = action.payload;
    const response = yield call(API.getPayments, orderId);
    if (typeof onSuccess === "function") {
      onSuccess(response.data);
    }
    yield put({
      type: GET_PAYMENTS_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_PAYMENTS_FAIL,
      payload: { error: error },
    });
  }
}

function* retryPaymentSaga(action) {
  try {
    const { orderId, onSuccess } = action.payload;
    const response = yield call(API.retryPayment, orderId);
    if (typeof onSuccess === "function") {
      onSuccess(response.data);
    }
    yield put({
      type: RETRY_PAYMENT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    if (typeof action.payload?.onError === "function") {
      action.payload.onError(error);
    }
    yield put({
      type: RETRY_PAYMENT_FAIL,
      payload: { error: error },
    });
  }
}

function* orderSaga() {
  yield takeLeading(ORDER_CREATE, orderCreate);
  yield takeLatest(CUSTOMER_ORDER_LIST, orderList);
  yield takeLatest(CUSTOMER_ORDER_DETAIL, orderDetail);
  yield takeLeading(CUSTOMER_ORDER_UPDATE, orderUpdate);
  yield takeLatest(PERSONAL_SHOPPER_LIST, personalShoperList);
  yield takeLatest(PERSONAL_SHOPPER_ASSIGN, personalShopperAssign);
  yield takeLeading(CREATE_PAYMENT_ORDER, createPaymentOrderSaga);
  yield takeLeading(VERIFY_PAYMENT, verifyPaymentSaga);
  yield takeLatest(GET_PAYMENTS, getPaymentsSaga);
  yield takeLeading(RETRY_PAYMENT, retryPaymentSaga);
}
export default orderSaga;
